export const environment = {
  production: true,
  version: '4.60.0-alpha.27',
  topdeskUrl: 'https://myservicedesk.simac.nl/tas/secure/mango/incident',
};
